import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import AccountRemoveRequest from './AccountRemoveRequest';
import { store } from '../../../store/store';
import { loadDOMComponent } from '../../../helpers';
import { AppContextProvider } from '../../../Services/AppContext';

loadDOMComponent({
	selector: 'react-account-remove',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AccountRemoveRequest />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
